//［dAgora］25/07/29 駐車場予約対応（駐車場商品の判定をDOMベース＋注意書き固定）
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';

        // 起動時チェック
        this.checkCustomerTagRestriction();
        // 追加：注意書きを常に表示し続ける
        this.keepWarningSticky();
      }

      /* ---------------- 注意書きを消させない仕組み ---------------- */
      keepWarningSticky() {
        const showIfReserved = () => {
          // 駐車場商品 かつ 予約タグ持ちなら、常に注意書きとボタン非表示を再適用
          if (this.isParkingProduct() && this.hasReservedTag()) {
            this.handleErrorMessage('既に駐車場予約をされています。駐車場予約はお一人様1件までとなります。');
            if (this.submitButton) this.submitButton.style.display = 'none';
          }
        };

        // 1) フォーム内の input/change で再表示（バリエーション切替に反応）
        if (this.form) {
          this.form.addEventListener('change', () => setTimeout(showIfReserved, 0));
          this.form.addEventListener('input',  () => setTimeout(showIfReserved, 0));
        }

        // 2) エラーメッセージ要素が外部処理で hidden にされても、即座に再表示
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (this.errorMessageWrapper && !this._stickyObserver) {
          this._stickyObserver = new MutationObserver(() => showIfReserved());
          this._stickyObserver.observe(this.errorMessageWrapper, {
            attributes: true,
            attributeFilter: ['hidden', 'class', 'style'],
          });
        }

        // 3) 初期描画直後にも一度適用
        setTimeout(showIfReserved, 0);
      }

      /* ---------------- ユーティリティ ---------------- */

      // この商品が「駐車場予約」かどうかをDOMで判定（専用プロパティ入力の有無で判断）
      isParkingProduct() {
        const timeField = document.querySelector('[name="properties[入庫時間帯]"]');
        const carField  = document.querySelector('[name="properties[車のナンバーと車種]"]');
        return !!(timeField && carField);
      }

      // 顧客タグ（data-customer-tags から取得）
      getCustomerTags() {
        const el = document.querySelector('[data-customer-tags]');
        if (!el || !el.dataset.customerTags) return [];
        return el.dataset.customerTags.split(',').map(t => t.trim()).filter(Boolean);
      }

      hasReservedTag() {
        const tags = this.getCustomerTags();
        const hit = tags.includes('駐車場予約済_26SPR');
        // デバッグ（公開時は消してOK）
        console.log('[parking] customer tags:', tags, 'hasReserved:', hit);
        return hit;
      }

      /* -------------- 顧客タグチェック（起動時） -------------- */
      checkCustomerTagRestriction() {
        if (!this.isParkingProduct()) return;

        if (this.hasReservedTag()) {
          if (this.submitButton) this.submitButton.style.display = 'none';
          this.handleErrorMessage('既に駐車場予約をされています。駐車場予約はお一人様1件までとなります。');
        }
      }

      /* ---------------- 送信処理 ---------------- */
      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        // 二重ガード：タグがあれば即STOP
        if (this.isParkingProduct() && this.hasReservedTag()) {
          this.handleErrorMessage('この商品は既にご予約済みのため、再度のご予約はできません。');
          this.submitButton?.classList.remove('loading');
          this.submitButton?.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          this.error = true;
          return;
        }

        // 同一会計内の重複（カート内）チェック
        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const hasParkingItem = cart.items.some((item) => {
            // プロパティ名からも判定（handle名に依存しない）
            const p = item.properties || {};
            const looksParkingByProps = Object.prototype.hasOwnProperty.call(p, '入庫時間帯')
                                     && Object.prototype.hasOwnProperty.call(p, '車のナンバーと車種');
            const looksParkingByHandle = (item.handle || '').includes('toko-club-parking'); // 保険
            return looksParkingByProps || looksParkingByHandle;
          });

          if (hasParkingItem) {
            this.handleErrorMessage('既に駐車場予約がカートにあります。駐車場予約はお一人様1件までとなります。');
            this.submitButton?.classList.remove('loading');
            this.submitButton?.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            this.error = true;
            return;
          }
        } catch (e) {
          console.error('[parking] cart check failed:', e);
        }

        // 駐車場商品のみ：入力バリデーション
        if (this.isParkingProduct()) {
          const timeSelect = document.querySelector('[name="properties[入庫時間帯]"]');
          const carInfo    = document.querySelector('[name="properties[車のナンバーと車種]"]');
          const errors = [];
          if (!timeSelect || (timeSelect.value || '').trim() === '') errors.push('入庫時間帯を選択してください。');
          if (!carInfo   || (carInfo.value   || '').trim()   === '') errors.push('ナンバーと車種を入力してください。');

          if (errors.length > 0) {
            this.handleErrorMessage(errors.join('／'));
            this.submitButton?.classList.remove('loading');
            this.submitButton?.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            this.error = true;
            return;
          }
        }

        // ここから通常の add to cart
        this.handleErrorMessage();
        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton?.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton?.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton?.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton?.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
